module.exports = __webpack_public_path__ + "img/preview-tv.72b21b87.png";